import DragonflySVG from "../assets/backedby/dragonfly.svg";
import ElectricCapitalSVG from "../assets/backedby/electric-capital.svg";
import WintermuteSVG from "../assets/backedby/wintermute.svg";
import CoinbaseSVG from "../assets/backedby/coinbase.svg";
import BSSVG from "../assets/backedby/balaji-srinivasan.svg";
import styles from "./BackedBy.module.scss";
import HashflowLogoSVG from "../assets/footer/hashflow.svg";
import { useNavigate } from "react-router-dom";

export const BackedBy = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.background}>
      <div className={styles.backedBy}>
        <h3>Backed by</h3>
        <div>
          <div className={styles.gradient}></div>
          <div className={styles.logos}>
            <img src={DragonflySVG} alt="dragonfly" />
            <img src={ElectricCapitalSVG} alt="electric capital" />
            <img src={WintermuteSVG} alt="wintermute" />
            <img src={CoinbaseSVG} alt="coinbase" />
            <img src={BSSVG} alt="balaji srinivasan" />
          </div>
        </div>
      </div>
      <footer>
        <img src={HashflowLogoSVG} alt="Hashflow" />
        <div>
          <h6>© Hashflow</h6>
          <h6 className={styles.link} onClick={() => navigate("/terms")}>
            Terms of Service
          </h6>
          <h6 className={styles.link} onClick={() => navigate("/privacy")}>
            Privacy Policy
          </h6>
        </div>
      </footer>
    </div>
  );
};
